export default class YandexMetricaService {
  static init(metricaId, userId = null, companyName = null) {
    // Yandex Metrica script'ini yükle
    (function(m,e,t,r,i,k,a){
      m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    // Yandex Metrica'yı başlat
    window.ym(metricaId, "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    });

    // Kullanıcı ID'si varsa gönder
    if (userId) {
      window.ym(metricaId, "setUserID", userId);

      // Company bilgisini custom parametre olarak gönder
      if (companyName) {
        window.ym(metricaId, "params", {
          company_name: companyName,
          user_id: userId
        });
      }
    }

    // Noscript tag'ini ekle
    const noscript = document.createElement('noscript');
    const div = document.createElement('div');
    const img = document.createElement('img');
    img.src = `https://mc.yandex.ru/watch/${metricaId}`;
    img.style.position = 'absolute';
    img.style.left = '-9999px';
    img.alt = '';
    div.appendChild(img);
    noscript.appendChild(div);
    document.body.appendChild(noscript);
  }

  // Kullanıcı ID'sini sonradan güncellemek için
  static setUserID(metricaId, userId) {
    if (window.ym && userId) {
      window.ym(metricaId, "setUserID", userId);
    }
  }

}
